import { CrossIcon } from '@src/Assets/svg/CrossIcon';
import { APP_EVENTS, APP_SESSION_KEYS } from '@src/constants/app-shell-constants';
import { ROUTES_PATHS } from '@src/constants/routes';
import { getHealthCareOrgName } from '@src/utility/common.service';
import { checkOnlySimulationMode } from '@src/utility/createStorage';
import React, { useCallback, useEffect, useState } from 'react';
import {
  Actions,
  Banner,
  ExitLink,
  Icon,
  IconButton,
  Message,
  ProviderName,
} from './ProviderBanner.styles';

const EXIT_PROVIDER_VIEW_EVENT = APP_EVENTS.EXIT_PROVIDER_VIEW;
const SELECTED_CORPORATE_TIN_UPDATE_EVENT = APP_EVENTS.SELECTED_CORPORATE_TIN_UPDATE;

const getBannerHealthSystemName = () => {
  try {
    const parsedState = JSON.parse(sessionStorage.getItem(APP_SESSION_KEYS.STATE) || '{}');
    return parsedState?.selectedCorporateTin?.name || parsedState?.uhc?.selectedCorporateTin?.name || getHealthCareOrgName();
  } catch {
    return getHealthCareOrgName();
  }
};

export const ProviderBanner: React.FC = () => {
  const [activeProviderMode, setActiveProviderMode] = useState(() => checkOnlySimulationMode());
  const [healthSystemName, setHealthSystemName] = useState(() => getBannerHealthSystemName());

  const syncBannerState = useCallback((detail?: boolean) => {
    setActiveProviderMode(
      typeof detail === 'boolean' ? detail : checkOnlySimulationMode()
    );
    setHealthSystemName(getBannerHealthSystemName());
  }, []);

  useEffect(() => {
    const handleExitProviderView = (event: Event) => {
      syncBannerState((event as CustomEvent<boolean>)?.detail);
    };

    const handleSelectedCorporateTinUpdate = () => {
      setHealthSystemName(getBannerHealthSystemName());
    };

    window.addEventListener(EXIT_PROVIDER_VIEW_EVENT, handleExitProviderView);
    window.addEventListener(SELECTED_CORPORATE_TIN_UPDATE_EVENT, handleSelectedCorporateTinUpdate);
    return () => {
      window.removeEventListener(EXIT_PROVIDER_VIEW_EVENT, handleExitProviderView);
      window.removeEventListener(SELECTED_CORPORATE_TIN_UPDATE_EVENT, handleSelectedCorporateTinUpdate);
    };
  }, [syncBannerState]);

  const onExitClick = () => {
    const isPsmsFlow = sessionStorage.getItem(APP_SESSION_KEYS.PSMS_REPORT_CARD_CLICKED) === 'true';
    sessionStorage.setItem(APP_SESSION_KEYS.SIMULATION_MODE, 'false');
    syncBannerState(false);
    window.dispatchEvent(new CustomEvent(EXIT_PROVIDER_VIEW_EVENT, { detail: false }));
    window.dispatchEvent(
      new CustomEvent(APP_EVENTS.REACT_NAVIGATION, {
        detail: {
          url: isPsmsFlow ? ROUTES_PATHS.PSMS.Summary : ROUTES_PATHS.Overview.OverviewAdvocate,
        },
      })
    );
  };

  if (!activeProviderMode) {
    return null;
  }

  return (
    <Banner>
      <Actions>
        <IconButton onClick={onExitClick} title="Exit Provider View">
          <Icon>
            <CrossIcon />
          </Icon>
        </IconButton>
        <ExitLink onClick={onExitClick}>
          Exit Provider View
        </ExitLink>
      </Actions>
      <Message title={healthSystemName}>
        <span>
          You are viewing as <ProviderName>{healthSystemName}</ProviderName>
        </span>
      </Message>
    </Banner>
  );
};